import { render, staticRenderFns } from "./question-home.vue?vue&type=template&id=f7f0dc3a&scoped=true"
import script from "./question-home.vue?vue&type=script&lang=js"
export * from "./question-home.vue?vue&type=script&lang=js"
import style0 from "./question-home.vue?vue&type=style&index=0&id=f7f0dc3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f0dc3a",
  null
  
)

export default component.exports